export const trackEvent = (name: string): void => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({event: name})
  console.log("Event", name)
}
